import {Pipe, PipeTransform} from '@angular/core';
import {LanguageService} from "../services/resources/language.service";
import {TranslationModel} from "../models/resources/translation.model";

@Pipe({
  name: 'language',
  standalone: true
})
export class LanguagePipe implements PipeTransform {

  constructor(private languageService: LanguageService) {
  }

  transform(object: any): any {
    let translation = null;
    if (this.languageService.activeLanguage())
      translation = object.find((t: TranslationModel) => t.languageId == this.languageService.activeLanguage()!.id)?.text

    return translation;
  }
}
